import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { useTheme } from '../../../../../../../theming/useTheme';
import { generateLinkStyleFromTheme, TextLinkComponent } from '../../../../../../partials/link/TextLink';
import { P } from '../../../../../../../typography/semanticTags';
import { BaseUnit } from '../../../../../../../theming/baseUnitDefinition';

const componentConfigThemeKey = 'menuSubLink';

export interface Link {
  href: string;
  text: string;
}

export interface MenuLinkDataProps {
  link: Link;
  childrenLinks: MenuLinkDataProps[] | null;
}

interface MenuSubLinkThemeProps {
  baseUnit: BaseUnit;
  idleColor: string;
}

const getMenuSubLinkStyle = () => StyleSheet.create({
  style: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
});

export const MenuSubLink: React.FunctionComponent<Link> = props => {
  const { href, text } = props;
  const { idleColor } = useTheme<MenuSubLinkThemeProps>(componentConfigThemeKey);
  const linkStyle = generateLinkStyleFromTheme({ idleColor });
  const style = getMenuSubLinkStyle();
  return (
    <li className={css(style.style)}>
      <TextLinkComponent href={href} linkStyle={linkStyle}>
        <P>{text}</P>
      </TextLinkComponent>
    </li>
  );
};
